import type { GameInfoType } from '@patrianna/shared-patrianna-types/store/SlotGameFlowModule'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import MaxWinContainer from 'components/MaxWinContainer'
import MinMaxContainer from 'components/MinMaxContainer'
import TopPrizeContainer from 'components/TopPrizeContainer'
import content from 'prismic-translates/start-game-dialog.json'
import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

type Props = {
  activeCurrency: SupportedCurrencies
  gameBetsAndPrizes: GameInfoType & { maxWinMultiplier: number }
  isDarkMode: boolean
  descriptionColor: string
  isLoggedIn: boolean
}

function PrizeInfo(props: Props) {
  const { activeCurrency, gameBetsAndPrizes, descriptionColor, isDarkMode, isLoggedIn } = props
  const t = getTranslationFromJson([content])

  if (!gameBetsAndPrizes) {
    return null
  }

  return !isLoggedIn ? (
    <>
      {Boolean(gameBetsAndPrizes.maxWinMultiplier) && (
        <div className={cx(classes.gameInfoCol, isDarkMode && classes.darkMode)}>
          <MaxWinContainer
            title={t('max_win')}
            gameBetsAndPrizes={gameBetsAndPrizes}
            captionClassName={cx('mt-typography-caption', classes.caption, isDarkMode && classes.captionDarkMode)}
            descriptionClassName={cx('mt-typography-caption', classes.description, descriptionColor)}
          />
        </div>
      )}
    </>
  ) : (
    <>
      {Boolean(gameBetsAndPrizes.maxBet) && Boolean(gameBetsAndPrizes.minBet) && (
        <div className={cx(classes.gameInfoCol, isDarkMode && classes.darkMode)}>
          <MinMaxContainer
            gameBetsAndPrizes={gameBetsAndPrizes}
            activeCurrency={activeCurrency}
            isDarkMode={isDarkMode}
            descriptionColor={descriptionColor}
            title={t('min_max')}
            captionClassName='gameLandingCaption'
            descriptionClassName='gameLandingDescription'
            isGameDescription
          />
        </div>
      )}
      {Boolean(gameBetsAndPrizes.maxPrize) && (
        <div className={cx(classes.gameInfoCol, isDarkMode && classes.darkMode)}>
          <TopPrizeContainer
            gameBetsAndPrizes={gameBetsAndPrizes}
            activeCurrency={activeCurrency}
            isDarkMode={isDarkMode}
            descriptionColor={descriptionColor}
            title={t('top_prize')}
            captionClassName='gameLandingCaption'
            descriptionClassName='gameLandingDescription'
          />
        </div>
      )}
    </>
  )
}

export default PrizeInfo
